import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../assets/images/logo/fricontrolIcon.png'


const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  width: "80",
  alt: "Alba by Fricontrol"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs-5",
  style: {"padding-top":"30px"}
}, "Bienvenid@", -1)
const _hoisted_4 = {
  class: "fw-bold mt-2",
  style: {"font-size":"40px","line-height":"40px"}
}
const _hoisted_5 = {
  key: 1,
  class: "text-lg fw-bold mt-2"
}
const _hoisted_6 = {
  class: "py-4 text-left friBackWhite3 br-8",
  style: {"max-width":"365px"}
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  class: "fs-5 fw-bold",
  style: {"line-height":"20px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs3" }, "Alba Hub", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs3 pt-2 friColor1" }, "Configurar", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px","width":"2px","background-color":"#ccc","margin":"0 0 0 65px"} }, null, -1)
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "text-xs3" }
const _hoisted_18 = {
  key: 0,
  class: "text-xs3 friColor3"
}
const _hoisted_19 = {
  key: 1,
  class: "text-xs3 friColor2"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-exclamation-triangle friColor3",
  style: {"font-size":"50px","line-height":"50px"}
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-exclamation-triangle friColor2",
  style: {"font-size":"50px","line-height":"50px"}
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-check-lg friColor1",
  style: {"font-size":"40px","line-height":"40px","opacity":"0.5"}
}, null, -1)
const _hoisted_23 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_Weather = _resolveComponent("Weather")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.isMobile ? 'text-left p-0 m-0' : 'text-center'),
    style: _normalizeStyle([!_ctx.isMobile ? 'padding-top: 30px' : '', {"background-color":"#ebebeb !important","padding-bottom":"150px !important"}]),
    id: _ctx.layout.loading  && _ctx.isMobile ? 'friDashPage' : ''
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.isMobile ? 'ps-3' : '')
    }, [
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : _createCommentVNode("", true),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.profile?.first), 1),
      (_ctx.profile.isAgent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Agente"))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", null, [
      (_ctx.layout.apps && _ctx.layout.apps.apps && Object.keys(_ctx.layout.apps.apps).length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["p-0 m-0 mt-5", _ctx.isMobile ? '' : 'pt-5'])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.apps.apps, (app, appId) => {
              return (_openBlock(), _createElementBlock("div", { key: appId }, [
                _createElementVNode("div", {
                  class: "ps-3 flex align-items-center justify-content-center mb-4",
                  style: _normalizeStyle(_ctx.isMobile ? '' : 'margin: 0 auto;width: 370px;')
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["text-left friBackWhite mx-4 p-2 br-8", _ctx.profile.isClient || _ctx.profile.isAgent ? 'cursor-pointer' : 'cursor-default']),
                      onClick: ($event: any) => (_ctx.profile.isClient || _ctx.profile.isAgent ? _ctx.$router.push({ path: '/device/' + appId, query: { section:  'dashboard' } }) : '')
                    }, [
                      _createVNode(_component_ion_row, { class: "align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            style: {"max-width":"100px !important"},
                            class: "p-0 m-0"
                          }, {
                            default: _withCtx(() => [
                              (app.logo)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createElementVNode("img", {
                                      src: app.logo,
                                      slot: "start",
                                      style: {"width":"90px"},
                                      class: "mt-1"
                                    }, null, 8, _hoisted_9)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_col, { class: "text-left pt-2" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, _toDisplayString(app.name), 1),
                              _hoisted_11,
                              (_ctx.profile.isClient)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ], 10, _hoisted_7),
                    (app.scenes && app.scenes?.scenes)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(app.scenes.scenes, (scene, sceneId) => {
                          return (_openBlock(), _createElementBlock("div", { key: sceneId }, [
                            _hoisted_15,
                            _createElementVNode("div", {
                              class: _normalizeClass(["text-left mx-5 py-2 br-8 cursor-pointer", scene.isAlarm ? 'friBackWhite friBorder4' : 'friBackWhite']),
                              onClick: ($event: any) => (_ctx.$router.push({ path: '/site/'+ appId + '/' + sceneId, query: { section:  'dashboard' } }))
                            }, [
                              _createVNode(_component_ion_row, { class: "p-0 m-0" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    class: "text-left px-4",
                                    style: {"max-width":"280px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["fw-bold align-middle", scene.name && scene.name.toString().length > 15 ? 'fs-6' : 'fs-5']),
                                        style: {"line-height":"20px"}
                                      }, _toDisplayString(scene.name), 3),
                                      _createElementVNode("div", _hoisted_17, _toDisplayString(scene.typeName), 1),
                                      (scene.isAlarm)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Requiere atención"))
                                        : _createCommentVNode("", true),
                                      (scene.isOffInterval)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Requiere atención"))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (scene.isAlarm)
                                    ? (_openBlock(), _createBlock(_component_ion_col, {
                                        key: 0,
                                        class: "text-center pt-3",
                                        style: {"max-width":"100px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_20
                                        ]),
                                        _: 1
                                      }))
                                    : (scene.isOffInterval)
                                      ? (_openBlock(), _createBlock(_component_ion_col, {
                                          key: 1,
                                          class: "text-center pt-3",
                                          style: {"max-width":"100px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_21
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_ion_col, {
                                          key: 2,
                                          class: "text-center pt-2",
                                          style: {"max-width":"100px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_22
                                          ]),
                                          _: 1
                                        }))
                                ]),
                                _: 2
                              }, 1024)
                            ], 10, _hoisted_16)
                          ]))
                        }), 128))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_Weather, { app: app }, null, 8, ["app"])
                    ])
                  ])
                ], 4)
              ]))
            }), 128))
          ], 2))
        : _createCommentVNode("", true)
    ])
  ], 14, _hoisted_1))
}